import type { ReactNode } from "react";
import { Button } from "@heroui/react";
import type { ButtonRootProps } from "@heroui/react";
import clsx from "clsx";
import styles from "./LightboxButton.module.scss";

/* UI-DESIGN: the lightbox CTA pair wraps HeroUI's Button (press handling,
   focus ring, disabled state) and only restyles it: red primary, glass
   secondary, 54px tall like the frame. */
type LightboxButtonProps = Omit<ButtonRootProps, "variant" | "className" | "children"> & {
  /* quiet: a text-weight action beside the CTA (still a 48px target) */
  tone?: "primary" | "secondary" | "quiet";
  icon?: ReactNode;
  trailing?: ReactNode;
  className?: string;
  children: ReactNode;
};

const LightboxButton = ({
  tone = "primary",
  icon,
  trailing,
  className,
  children,
  ...rest
}: LightboxButtonProps) => (
  <Button
    {...rest}
    variant={tone === "primary" ? "primary" : "secondary"}
    className={clsx(styles.button, styles[tone], className)}
  >
    {icon ? <span className={styles.icon} aria-hidden>{icon}</span> : null}
    <span>{children}</span>
    {trailing ? <span className={clsx(styles.icon, styles.trailing)} aria-hidden>{trailing}</span> : null}
  </Button>
);

export default LightboxButton;
